import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ROUTES from '../../assets/routes'
import { matchRoute } from '../../util/routes'
import pathStepsMap from './tourStepsMap'
import { TourStep } from './tour.typings'

const TOUR_ROUTES = [
    { path: ROUTES.chart, key: 'chart' },
    { path: ROUTES.optionChain, key: 'option-chain' },
    { path: ROUTES.openInterest, key: 'multi-strike-chart' },
    { path: ROUTES.screener, key: 'screener' },
    { path: ROUTES.fiiDii, key: 'fii-dii' },
    { path: ROUTES.strategyBuilder, key: 'strategy-builder' }
]

/** Guided-tour steps defined for the current route, or an empty list. */
export const useRouteTourSteps = (): TourStep[] => {
    const location = useLocation()
    return useMemo(() => {
        const matched = matchRoute(location.pathname, TOUR_ROUTES)
        return matched && pathStepsMap[matched] ? pathStepsMap[matched] : []
    }, [location.pathname])
}
